import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "app/storybookComponents/Button";
import CriteriaLogoFull from "resources/icons/criteria-logo-full.svg";
import { getAuthenticatedAppUrl } from "app/containers/LoginlessWeeklyCheckinView/helpers";
import "./Chat.scss";

interface Props {
  readonly onNavigate?: () => void;
  readonly navigationUrl?: string;
  readonly navigationLabel?: string;
  readonly showNavigation?: boolean;
  readonly threadId?: string;
}

export default function LoginlessHeader({
  onNavigate,
  navigationUrl,
  navigationLabel = "Go to Develop",
  showNavigation = true,
  threadId,
}: Props) {
  const handleNavigate = () => {
    if (onNavigate) {
      onNavigate();
    } else {
      // Deep link to conversation if threadId is available, otherwise go to base URL
      const url = navigationUrl || getAuthenticatedAppUrl(threadId);
      window.open(url, "_blank", "noopener");
    }
  };

  return (
    <div className="loginless-header__container">
      <div className="loginless-header__content">
        {/* Left side - Logo */}
        <div className="loginless-header__logo-container">
          <img
            src={CriteriaLogoFull}
            alt="Criteria Logo"
            className="loginless-header__logo"
          />
        </div>

        {/* Right side - Navigation button */}
        {showNavigation && (
          <Button
            onClick={handleNavigate}
            className="border-0"
            variant="secondary-blue"
          >
            {navigationLabel}{" "}
            <FontAwesomeIcon icon="arrow-right" className="ms-2" />
          </Button>
        )}
      </div>
    </div>
  );
}
